module.exports = __webpack_public_path__ + "static/media/SORGHUM_1x.869df157.png";